/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProviderAuthenticateCallbackResponse } from '../models/ProviderAuthenticateCallbackResponse';
import type { ProviderAuthenticateResponse } from '../models/ProviderAuthenticateResponse';
import type { ProviderPaymentCallbackResponse } from '../models/ProviderPaymentCallbackResponse';
import type { ProviderPaymentResponse } from '../models/ProviderPaymentResponse';
import type { ProviderPaymentStatusResponse } from '../models/ProviderPaymentStatusResponse';
import type { ProviderSyncResponse } from '../models/ProviderSyncResponse';
import { request as __request } from '../core/request';

export class ProviderService {

    /**
     * @returns ProviderAuthenticateResponse
     * @throws ApiError
     */
    public static async providerAuthenticate({
        code,
    }: {
        code?: string | null,
    }): Promise<ProviderAuthenticateResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/provider/authenticate`,
            query: {
                'code': code,
            },
        });
        return result.body;
    }

    /**
     * @returns ProviderAuthenticateCallbackResponse
     * @throws ApiError
     */
    public static async providerAuthenticateCallback({
        code,
    }: {
        code?: string | null,
    }): Promise<ProviderAuthenticateCallbackResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/provider/authenticate/callback`,
            query: {
                'code': code,
            },
        });
        return result.body;
    }

    /**
     * @returns ProviderSyncResponse
     * @throws ApiError
     */
    public static async providerSync(): Promise<ProviderSyncResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/provider/sync`,
        });
        return result.body;
    }

    /**
     * @returns ProviderPaymentResponse
     * @throws ApiError
     */
    public static async providerPayment({
        code,
    }: {
        code?: string | null,
    }): Promise<ProviderPaymentResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/provider/payment`,
            query: {
                'code': code,
            },
        });
        return result.body;
    }

    /**
     * @returns ProviderPaymentCallbackResponse
     * @throws ApiError
     */
    public static async providerPaymentsCallback({
        paymentId,
    }: {
        paymentId?: string | null,
    }): Promise<ProviderPaymentCallbackResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/provider/payment/callback`,
            query: {
                'paymentId': paymentId,
            },
        });
        return result.body;
    }

    /**
     * @returns ProviderPaymentStatusResponse
     * @throws ApiError
     */
    public static async providerPaymentsStatus(): Promise<ProviderPaymentStatusResponse> {
        const result = await __request({
            method: 'POST',
            path: `/api/provider/payment/check`,
        });
        return result.body;
    }

}